import Papa from 'papaparse';
import moment from 'moment';
import Highcharts from 'highcharts';


const data_sectors = [
    { name: "Semiconductor Equipment", y: 24},
    { name: "Computer Software", y: 17},
    { name: "AI Model", y: 12},
    { name: "Aerospace/Defense", y: 9},
    { name: "Networking Products", y: 8},
    { name: "Commer Banks Non-US", y: 5},
    { name: "Electronic Forms ", y: 4},
    { name: "Medical Information Sys", y: 4},
    { name: "Enterprise Software/Serv", y: 3},
    { name: "Electronic Compo-Semicon", y: 2},
    { name: "E-Commerce/Services ", y: 2},
    { name: "Diversified Minerals", y: 1},
    { name: "Retail-Automobile", y: 1},
]

export function initSectorChart() {
    Highcharts.chart('sector-pie-chart', {
        title: {
            text: null,
        },

        chart: {
            plotBackgroundColor: null,
            backgroundColor: 'transparent',
            style: {
                fontFamily: 'Filson Pro',
            },
            type: 'pie',
            height: 460,
            
        },

        subtitle: {
            text: null,
        },

        credits: {
            enabled: false,
        },

        legend: {
            enabled: true,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            itemMarginTop: 15,
            symbolRadius: 0,
            itemStyle: {
                fontSize: '14px',
            },
            labelFormatter: function() {
                var val = parseFloat(this.y).toFixed(0);
                return `${this.name} - ${val}%`
            }
        },

        plotOptions: {
            pie: {
                colors: [
                    "#C9D0D6",
                    "#B5BFC8",
                    "#A1AFBB",
                    "#8599AA",
                    "#608097",
                    "#156082",
                    "#135A7B",
                    "#115472",
                    "#0F4E6A",
                    "#0D4661",
                    "#0A3E55",
                    "#072e3f",
                ],
                borderWidth: 0,
                innerSize: '30%',
                allowPointSelect: true,
                cursor: 'pointer',
                showInLegend: true,
                dataLabels: {
                    enabled: false,
                }
            },
        },

        tooltip: {
            xDateFormat: '%B %e, %Y',
            valueDecimals: 2,
            valueSuffix: "%",
            shared: true,
            style: {},
            backgroundColor: '#fff',
            borderWidth: 0,
        },

        series: [
            {
                name: 'Sectors',
                data: data_sectors,
            },
        ],

        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500,
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                        },
                    },
                },
            ],
        },
    });
}
